import { EBatchFlow } from '@shared/interface';

export class SetSelectedBatchFlow {
	static readonly type = '[Inventory Shared] Set Selected Batch Flow';
	constructor(public batchFlow: EBatchFlow) {}
}
